import { render, staticRenderFns } from "./MarkNotAttended.vue?vue&type=template&id=79873af0"
import script from "./MarkNotAttended.vue?vue&type=script&lang=js"
export * from "./MarkNotAttended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports